import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { spreadsData } from "../mock";

const tabs = ["Popular", "Forex", "Commodities", "Share CFDs", "Indices", "Crypto CFDs"];

const InstrumentIcon = ({ name, flag }) => {
  if (flag) {
    return (
      <div className="w-9 h-9 rounded-full bg-white/8 flex items-center justify-center text-base overflow-hidden">
        <span>{flag}</span>
      </div>
    );
  }
  const initials = name.slice(0, 2).toUpperCase();
  const colorMap = {
    Gold: "#f5b800",
    Silver: "#b8b8c0",
    Bitcoin: "#f7931a",
    Ethereum: "#627eea",
    Ripple: "#23a7d4",
    Litecoin: "#345d9d",
    Solana: "#9945ff",
    Apple: "#ffffff",
    Tesla: "#e82127",
    Amazon: "#ff9900",
    Netflix: "#e50914",
    NVIDIA: "#76b900",
    "US Crude Oil": "#1a1a1a",
    "Brent Crude Oil": "#1a1a1a",
    Copper: "#b87333",
  };
  const c = colorMap[name] || "#1c3df5";
  return (
    <div
      className="w-9 h-9 rounded-full flex items-center justify-center text-[11px] font-bold text-black"
      style={{ background: c }}
    >
      {initials}
    </div>
  );
};

const SpreadsTable = () => {
  const [active, setActive] = useState("Popular");
  const rows = spreadsData[active];

  return (
    <section className="py-20 lg:py-28 relative">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <h2 className="font-display text-[36px] lg:text-[52px] leading-[1.05] font-bold text-white mb-6">
              Sharper prices.<br />
              Faster trades.<br />
              <span className="text-[#7d8eff]">Greater opportunities.</span>
            </h2>
            <p className="bb-text-mute text-[16px] leading-relaxed mb-8 max-w-lg">
              Northwind delivers ultra-tight spreads, low fees, and lightning-fast execution powered by deep liquidity from top-tier providers. Focus on trading, and we'll handle the rest. Check out spreads on popular markets.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 bb-blue text-white font-medium rounded-lg transition-all hover:gap-3"
              >
                Open live account <ArrowRight size={16} />
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 border border-white/20 hover:border-white/40 text-white font-medium rounded-lg transition-all"
              >
                Free demo
              </a>
            </div>
          </div>

          <div className="bb-card rounded-3xl p-2 lg:p-3 overflow-hidden">
            <div className="flex gap-1 overflow-x-auto p-2 border-b border-white/5">
              {tabs.map((t) => (
                <button
                  key={t}
                  onClick={() => setActive(t)}
                  className={`px-4 py-2 text-[13px] font-medium rounded-lg whitespace-nowrap transition-all ${
                    active === t
                      ? "bg-white text-[#07080d]"
                      : "text-white/65 hover:text-white hover:bg-white/5"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>

            <div className="px-1 sm:px-3 pt-3 pb-2 overflow-x-auto">
              <div className="min-w-[460px]">
                <div className="grid grid-cols-[1.6fr_1fr_1fr_0.8fr_0.6fr] gap-3 px-3 sm:px-4 pb-3 text-[11px] uppercase tracking-wider text-white/40 font-semibold border-b border-white/5">
                  <span>Instrument</span>
                  <span className="text-right">Bid</span>
                  <span className="text-right">Ask</span>
                  <span className="text-right">Spread</span>
                  <span></span>
                </div>
                {rows.map((r) => (
                  <div
                    key={r.name}
                    className="grid grid-cols-[1.6fr_1fr_1fr_0.8fr_0.6fr] gap-3 items-center px-3 sm:px-4 py-3.5 rounded-xl hover:bg-white/[0.03] transition-colors"
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      <InstrumentIcon name={r.name} flag={r.flag} />
                      <span className="text-white font-medium text-[14px] truncate">{r.name}</span>
                    </div>
                    <span className="text-right text-white text-[14px] tabular-nums">{r.bid}</span>
                    <span className="text-right text-white text-[14px] tabular-nums">{r.ask}</span>
                    <span className="text-right text-[#7d8eff] text-[14px] font-medium tabular-nums">{r.spread}</span>
                    <a
                      href="#"
                      className="justify-self-end w-8 h-8 rounded-full bg-[#1c3df5] hover:bg-[#1530d8] flex items-center justify-center text-white transition-all"
                      aria-label="Trade"
                    >
                      <ArrowRight size={14} />
                    </a>
                  </div>
                ))}
              </div>
            </div>
            <div className="px-6 py-3 text-[11px] text-white/35 border-t border-white/5">
              Live prices are indicative only. Check your platform for the most up-to-date prices.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpreadsTable;
